export const getPhoneNumberWithoutAreaCode = (phoneNumber: string) => phoneNumber?.replaceAll('-', '')?.slice(-9);
